
/**
 * Saves a user to localStorage store. Anything provided that we have mapped to the store will be saved.
 * @param {*} user The user data.
 */
export function saveUser(response) {
  const { accessToken, refreshToken, expired, max_polygons_per_job, permissions, company, userData  } = response;
  if (accessToken !== undefined) localStorage.setItem("accessToken", accessToken);
  if (refreshToken !== undefined) localStorage.setItem("refreshToken", refreshToken);
  if (expired !== undefined) localStorage.setItem('_e', JSON.stringify(expired));
  if (max_polygons_per_job !== undefined) localStorage.setItem('_mppj', JSON.stringify(max_polygons_per_job));
  if (permissions !== undefined)  localStorage.setItem('_p', JSON.stringify(permissions));
  if (company !== undefined)  localStorage.setItem('_c', JSON.stringify(company));
  if (userData !== undefined) {
    localStorage.setItem("_ud", JSON.stringify(userData));
  }
}

export function saveNPAASUser(response) {
  const { defaultCompanyId, companies } = response;
  console.log(defaultCompanyId, companies);
  if (defaultCompanyId !== undefined) localStorage.setItem("_dcid", defaultCompanyId);
  if (defaultCompanyId !== undefined) localStorage.setItem("_scid", defaultCompanyId); // selected company id
  if (companies !== undefined) localStorage.setItem("_cs", JSON.stringify(companies));
}